import { useTranslation } from 'react-i18next';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function useLostChangesModal() {
  const storage = useStorage();
  const { spotRef } = storage;
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });
  const { t } = useTranslation();

  function didOpen() {
    analyticsPageView('Ordering Quit');
  }

  async function show({ forceLostMessage } = { forceLostMessage: false }) {
    await swal.fire({
      title:
        spotRef.current?.prepaid && !forceLostMessage
          ? t('lost-changes-modal.not-added')
          : t('lost-changes-modal.not-sent'),
      text:
        spotRef.current?.prepaid && !forceLostMessage
          ? t('lost-changes-modal.not-added.reason')
          : t('lost-changes-modal.not-sent.reason'),
      icon: forceLostMessage && !spotRef.current?.prepaid ? 'warning' : 'error',
      didOpen,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: t('close'),
    });
  }

  return {
    showLostChangesModal: show,
  };
}

export { useLostChangesModal };
